import {
  TicketCapturingIcon,
  TicketForceplateIcon,
  TicketSubscriptionIcon,
} from "icons";

export const tickets = [
  {
    id: 1,
    issueType: "Subscription",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 2,
    issueType: "Subscription",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 3,
    issueType: "Subscription",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 4,
    issueType: "Subscription",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 5,
    issueType: "Subscription",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 6,
    issueType: "Capturing",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 7,
    issueType: "Capturing",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 8,
    issueType: "Capturing",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 9,
    issueType: "Capturing",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 10,
    issueType: "Capturing",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 11,
    issueType: "Force Plates",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 12,
    issueType: "Force Plates",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 13,
    issueType: "Force Plates",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 14,
    issueType: "Force Plates",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 15,
    issueType: "Force Plates",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 16,
    issueType: "Calibration",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 17,
    issueType: "Calibration",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 18,
    issueType: "Calibration",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 19,
    issueType: "Calibration",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
  {
    id: 20,
    issueType: "Calibration",
    title: "I am not able to capture the swings?",
    desc: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor",
    postedAt: "12:45 AM",
  },
];

export const issueTypeColors = {
  Subscription: "#F63E50",
  Capturing: "#46B764",
  "Force Plates": "#F4BD00",
  Calibration: "#F63E50",
};
export const issueTypeIcons = {
  Subscription: TicketSubscriptionIcon,
  Capturing: TicketCapturingIcon,
  "Force Plates": TicketForceplateIcon,
  Calibration: TicketSubscriptionIcon,
};
